import { useContext } from 'react';
import { UserContext } from '../contexts/UserContext';
import { useContact } from '../contexts/ContactContext';
import SEO from '../components/SEO';

const GetStarted = () => {
  const { firestoreUser } = useContext(UserContext);
  const { openContact } = useContact();

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F7F3EB', minHeight: 'calc(100vh - var(--navbar-height, 125px))', display: 'flex', flexDirection: 'column' }}>
      <SEO
        title="Get Started"
        description="Learn how to get started trading guitar pedals on PedalxChange. Create your account, list your pedals, and start trading with musicians worldwide."
        url="https://pedalxchange.com/get-started"
        keywords="get started trading pedals, how to trade guitar pedals, pedal trading account, PedalxChange signup"
      />
      {/* Header and Body Text Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" style={{ paddingTop: '2rem', paddingBottom: '1rem' }}>
        <div className="getstarted-text-container" style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <h2 className="text-3xl font-bold text-gray-900" style={{ textAlign: 'center', fontSize: '1.875rem', marginBottom: '1rem', lineHeight: '1.2' }}>
            Trade pedals. Not dollars.
          </h2>
          <p className="text-lg font-semibold text-gray-700" style={{ maxWidth: '800px', margin: '0 auto', lineHeight: '1.6' }}>
            Trade the gear collecting dust for the gear that excites you. No selling on one platform just to fund a purchase on another. Skip the double marketplace fees, the buyer hunt, and the listing grind. Browse listings, send offers, or let smart matches connect you with the gear you've been looking for.
          </p>
        </div>
        <style jsx>{`
          @media (max-width: 768px) {
            .getstarted-text-container {
              padding: 0 1rem !important;
              box-sizing: border-box !important;
            }
            .getstarted-text-container h2 {
              max-width: 100% !important;
              word-wrap: break-word !important;
              font-size: 1.5rem !important;
            }
            .getstarted-text-container p {
              max-width: 100% !important;
              word-wrap: break-word !important;
              font-size: 1rem !important;
              padding: 0 0.5rem !important;
            }
            .svg-container {
              padding-left: 0.5rem !important;
              padding-right: 0.5rem !important;
              max-width: 100vw !important;
              overflow-x: hidden !important;
            }
            .max-w-7xl {
              padding-left: 0.5rem !important;
              padding-right: 0.5rem !important;
              max-width: 100vw !important;
            }
          }
        `}</style>
      </div>

      {/* SVG Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 svg-container" style={{ paddingTop: '0rem', paddingBottom: '2rem' }}>
        <div style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
          <img 
            src="/images/getstarted.svg" 
            alt="Get Started Guide"
            className="responsive-svg"
            style={{ 
              height: 'auto',
              backgroundColor: 'transparent',
              mixBlendMode: 'multiply',
              marginTop: '0rem',
              marginLeft: 'auto',
              marginRight: 'auto',
              display: 'block',
              pointerEvents: 'none'
            }}
          />
          <style jsx>{`
            .responsive-svg {
              max-width: 85%;
              transform: translateX(15px);
            }
            @media (max-width: 768px) {
              .responsive-svg {
                margin-top: 0rem !important;
                max-width: 100% !important;
                padding: 0 !important;
                transform: none !important;
                width: 100% !important;
                height: auto !important;
              }
            }
          `}</style>
          {/* Clickable overlay for the bottom gold button */}
          <a 
            href="/how-it-works" 
            style={{ 
              position: 'absolute',
              bottom: '3.5%',
              left: '49%',
              transform: 'translateX(-50%)',
              width: 'min(250px, 20%)',
              height: '4.5%',
              cursor: 'pointer',
              zIndex: 10
            }}
            title="How It Works"
          />
        </div>
        
        {/* Fee Structure Link */}
        <div style={{ textAlign: 'center', marginTop: '2rem', marginBottom: '1rem' }}>
          <a 
            href="/fees" 
            style={{
              fontFamily: 'Nunito, sans-serif',
              color: '#5A9ECB',
              fontWeight: 'bold',
              fontSize: '16px',
              textDecoration: 'none'
            }}
            className="hover:opacity-80 transition-opacity"
          >
            View Membership and Fee Structure
          </a>
        </div>
        
        {/* How It Works Button */}
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <a 
            href="/how-it-works"
            className="hover:opacity-80 transition-opacity"
            style={{
              display: 'inline-block',
              textDecoration: 'none',
              backgroundColor: '#C9A227',
              borderRadius: '9999px',
              border: 'none',
              padding: '12px 24px',
              fontFamily: 'Nunito, sans-serif',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '16px'
            }}
          >
            How It Works
          </a>
        </div>
      </div>
      
      {/* Footer */}
      <div className="bg-gray-100 border-t border-gray-200 py-4 mt-auto getstarted-footer">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <p className="text-xs sm:text-sm text-gray-600 px-2">
              Need help or found a bug?{' '}
              <button 
                onClick={() => openContact({ category: 'support' })}
                className="hover:underline break-words"
                style={{ 
                  color: '#5A9ECB',
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  font: 'inherit',
                  cursor: 'pointer'
                }}
              >
                Contact PXC Support
              </button>
            </p>
          </div>
        </div>
        <style jsx>{`
          @media (max-width: 768px) {
            .getstarted-footer {
              padding-left: 0.5rem !important;
              padding-right: 0.5rem !important;
              padding-bottom: 90px !important;
            }
            .getstarted-footer .max-w-7xl {
              padding-left: 0.5rem !important;
              padding-right: 0.5rem !important;
            }
          }
        `}</style>
      </div>
    </div>
  );
};

export default GetStarted; 